import { motion } from "framer-motion";
import { EASE } from "./Motion";
import { useLightbox } from "./Lightbox";

const SPAN = {
  3: "md:col-span-3", 4: "md:col-span-4", 5: "md:col-span-5", 6: "md:col-span-6",
  7: "md:col-span-7", 8: "md:col-span-8", 12: "md:col-span-12",
};

const Frame = ({ it, h, i, onOpen }) => (
  <motion.div
    role="button"
    tabIndex={0}
    aria-label="Expand image"
    onClick={onOpen}
    onKeyDown={(e) => e.key === "Enter" && onOpen()}
    data-testid="lightbox-trigger"
    className={`${it.half ? "col-span-1 aspect-square" : "col-span-2 aspect-[4/3]"} ${SPAN[it.span]} ${h} md:aspect-auto`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: i * 0.08 }}
  >
    <div className={`frame relative h-full cursor-zoom-in w-full overflow-hidden ${it.fit === "contain" ? "bg-white" : "bg-[#E2DDD3]"}`}>
      <motion.img
        src={it.src}
        alt=""
        loading="lazy"
        className={`frame-img absolute inset-0 h-full w-full ${it.fit === "contain" ? "object-contain p-4 md:p-8" : `object-cover ${it.pos || "object-center"}`}`}
        initial={{ scale: 1.18 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true, amount: 0.1 }}
        transition={{ duration: 1.6, ease: EASE }}
      />
    </div>
  </motion.div>
);

export const Collage = ({ rows, onOpen }) => {
  const { open } = useLightbox();
  const all = [...new Set(rows.flatMap((r) => r.items.map((it) => it.src)))];
  return (
    <div className="space-y-3 md:space-y-4">
      {rows.map((r, ri) => (
        <div key={ri} className="grid grid-cols-2 gap-3 md:grid-cols-12 md:gap-4">
          {r.items.map((it, i) => <Frame key={it.src + i} it={it} h={r.h} i={i} onOpen={() => (onOpen ? onOpen(all.indexOf(it.src)) : open(all, all.indexOf(it.src)))} />)}
        </div>
      ))}
    </div>
  );
};
